<template>
  <div id="AzaTashilats">
    <card back>
      <template v-slot:header>
        <h4>مشاهده تسهیلات عضو</h4>
        <hr />
      </template>
      <template v-slot:content>
        <DetailUser>
          <template v-slot:Pnl-r1>
            <h1 class="border-left"><i class="fad fa-user font-size-icon" style="font-size: 30px" title="مشخصات کاربر"></i></h1>
          </template>
          <template v-slot:Pnl-r2>
            <span>شماره مشتری : </span>
            <span class="font-weight-bold text-logo" dir="rtl"> {{ AzaInfo.ShomareOzv }}</span>
          </template>
          <template v-slot:Pnl-r3>
            <span>مشخصات : </span>
            <span class="font-weight-bold text-logo" dir="rtl">{{ AzaInfo.OzvName }} {{ AzaInfo.OzvFamily }}</span>
          </template>
          <template v-slot:Pnl-r4>
            <span>کد ملی : </span>
            <span class="font-weight-bold text-logo" dir="rtl">{{ AzaInfo.CodeMeli == null || AzaInfo.CodeMeli == '' ? '[ ثبت نشده ]' : AzaInfo.CodeMeli }}</span>
          </template>
        </DetailUser>
        <div class="mb-3 mt-3">
          <a v-if="AddModeAzaTashilat == 0" class="d-inline float-right mx-2 mt-1" href="javascript:;" @click="AddModeAzaTashilat = 1" title="افزودن حساب جدید">
            <h4><i class="fas fa-plus text-success" style="color: var(--logo-color) !important"></i></h4>
          </a>
          <a v-if="AddModeAzaTashilat != 0" class="d-inline float-right mx-2 mt-1" href="javascript:;" @click="AddModeAzaTashilat = 0;Refresh();" title="لغو افزودن">
            <h4><i class="fas fa-times text-danger"></i></h4>
          </a>
        </div>
        <div class="row" v-if="AddModeAzaTashilat != 0">
          <div class="col-12 mt-3">
            <b-tabs content-class="" align="left" active-nav-item-class="text-logo font-weight-bold">
              <b-tab title="اطلاعات عمومی | مبلغ و قسط" active>
                <!-- Line 1 -->
                <div class="row mb-5">
                  <div class="col-md-2 col-12 text-right">
                    <small id="LblTaahodatSelectForNahve">نوع تســهیلات</small>
                    <SearchableCombo
                      :edit="false"
                      :defaultvalue="DataAxios.TblNoeId"
                      @ResultCombo="ValueResultNoe"
                      :rownumintable="1"
                      :queryString="{ id: $session.get('UserInfo').tblShobeId }"
                      :action="'TblCombo/GetNoeTashilat'"
                      :method="'GET'"
                      :idinput="'TblNoeTashilat'"
                      :keyItem="'TblNoeTashilat'"
                      :disabled="false"
                    >
                    </SearchableCombo>
                  </div>
                  <div class="col-md-3 col-12 text-right">
                    <small id="LblVcode">شماره تســهیلات</small>
                    <input v-model="DataAxios.Vcode" disabled type="text" id="Vcode" class="form-control text-center" style="direction: ltr" />
                  </div>
                  <div class="col-md-3 col-12 text-right">
                    <small id="LblMavaredMasrafi">موارد مصرفی</small>
                    <input-option :IdEditMode="DataAxios.TblMavaredMasrafVamId" @Value_IN_OP="GetInfoDes" :IdElemnt="'MavaredMasrafi'" :ActionUrl="'b_AddMavaredMasrafVam'" :ActionUrlGet="'GetMavaredMasrafVam'"></input-option>
                  </div>
                  <div class="col-md-2 col-12 text-right">
                    <small id="LblTarix">تاریخ درخواست</small>
                    <date-picker :editable="true" v-model="DataAxios.Tarix"></date-picker>
                  </div>
                  <div class="col-md-2 col-12 text-right">
                    <small id="LblTarixShoroAghsat">شروع اقساط</small>
                    <date-picker :editable="true" v-model="DataAxios.TarixShoroAghsat"></date-picker>
                  </div>
                </div>
                <!-- Line2 -->
                <div v-if="IsSelectTashilatNoe" class="row mt-3 mb-3">
                  <div class="col-md-2 col-12 text-right">
                    <small id="LblMablaghVam">مبلغ تســهیلات</small>
                    <input
                      type="text"
                      @keypress="
                        $ValidNumber($event, 13, true)
                        $DotInMablagh($event, 13)
                      "
                      @focus="Focus($event)"
                      @focusout="
                        FocusOut($event)
                        CalcBedehiAvali($event)
                      "
                      @keyup="$PutCommatoInput()"
                      id="MablaghVam"
                      class="text-center form-control InputText 3ragham"
                      style="direction: ltr"
                      v-model="DataAxios.MablaghVam"
                    />
                  </div>

                  <div class="col-md-2 pr-0 col-12 text-right">
                    <small id="LblTedadGhestVam">تعداد اقساط</small>
                    <input
                      type="text"
                      v-model="DataAxios.TedadGhestVam"
                      @keypress="$ValidNumber($event, 2)"
                      @focus="Focus($event)"
                      @focusout="
                        FocusOut($event)
                        CalcMablaghHarGhest($event)
                      "
                      id="TedadGhestVam"
                      class="form-control text-center InputText"
                      style="direction: ltr"
                    />
                  </div>

                  <div class="col-md-3 col-12 text-right border-right mt-2">
                    <div class="row">
                      <div class="col-md-5 text-center col-12 pl-0 text-right mt-3">
                        <small id="LblPrgDoreTaahod"> فاصله بین اقساط </small>
                        <!-- <input type="text" @keypress="$ValidNumber($event, 12)" class="form-control InputText" style="direction: ltr" /> -->
                      </div>
                      <div class="col-md-7 col-12 pr-0 text-right mt-2">
                        <input type="text" @keypress="$ValidNumber($event, 3)" v-model="DataAxios.PrgDoreTaahod" id="PrgDoreTaahod" class="form-control text-center InputText" style="direction: ltr" />
                      </div>
                    </div>
                  </div>
                  <div class="col-md-2 col-12 pr-0 text-center mt-3">
                    <small id="LbltblComboPrgVahedTaahodat4" class="d-none"> بازه </small>
                    <SearchableCombo
                      :edit="false"
                      :defaultvalue="DataAxios.tblComboPrgVahedTaahodat4 ? DataAxios.tblComboPrgVahedTaahodat4 : (DataAxios.TblComboPrgVahedTaahodat4 = 8)"
                      @ResultCombo="ValueResultTblComboPrgVahed4"
                      :rownumintable="1"
                      :queryString="{ id: 4 }"
                      :action="'TblCombo/GettblCombo'"
                      :method="'GET'"
                      :idinput="'TblComboPrgVahedTaahodat4'"
                      :keyItem="'TblComboPrgVahedTaahodat4'"
                      :disabled="false"
                    >
                    </SearchableCombo>
                  </div>

                  <div class="col-md-3 col-12 pr-0 text-right mt-2">
                    <div class="row">
                      <div class="col-md-5 text-center col-12 pl-0 text-right mt-3">
                        <small id="LblMablaghGhestVam"> هر قسط به مبلغ </small>
                        <!-- <input type="text" @keypress="$ValidNumber($event, 12)" class="form-control InputText" style="direction: ltr" /> -->
                      </div>
                      <div class="col-md-7 col-12 pr-0 text-right mt-2">
                        <input
                          type="text"
                          @keypress="
                            $ValidNumber($event, 13)
                            $DotInMablagh($event, 13)
                          "
                          @keyup="$PutCommatoInput()"
                          @focusout="CalcTarixShoroAghsat($event)"
                          class="form-control text-center InputText 3ragham"
                          style="direction: ltr"
                          v-model="DataAxios.MablaghGhestVam"
                        />
                      </div>
                    </div>
                  </div>
                  <!-- Kaht badi -->

                  <div class="col-md-2 col-12 text-right mt-3">
                    <small id="LblMabLastGhest"> مبلغ آخرین قسط </small>
                    <input v-model="DataAxios.MabLastGhest" type="text" @keypress="$ValidNumber($event, 12)" id="MabLastGhest" class="form-control InputText 3ragham text-center" style="direction: ltr" />
                  </div>
                  <div class="col-md-2 col-12 pr-0 text-right mt-3 border-left">
                    <small id="LblMablaghAvalinGhest"> مبلغ اولین قسط </small>
                    <input v-model="DataAxios.MablaghAvalinGhest" type="text" @keypress="$ValidNumber($event, 12)" class="form-control InputText 3ragham text-center" style="direction: ltr" />
                  </div>
                  <div class="col-md-3 col-12 text-right mt-3">
                    <small id="LblMabTaeinKarmozd"> مبلغ کارمزد </small>
                    <input v-model="DataAxios.MabTaeinKarmozd" disabled type="text" tabindex="-1" @keypress="$ValidNumber($event, 12)" class="form-control InputText 3ragham" style="direction: ltr" />
                  </div>
                  <div class="col-md-2 col-12 text-right mt-3">
                    <small id="LblSumMabBedehi"> بدهی اولیه </small>
                    <input disabled type="text" v-model="DataAxios.SumMabBedehi" tabindex="-1" @keypress="$ValidNumber($event, 12)" class="form-control InputText" style="direction: ltr" />
                  </div>
                  <div class="col-md-3 col-12 text-right mt-3">
                    <small> نحوه دریافت کارمــزد </small>
                    <SearchableCombo
                      :edit="false"
                      :defaultvalue="TaahodatSelectForNahve ? TaahodatSelectForNahve : 4009"
                      @ResultCombo="ValueResultTaahodatSelectForNahve"
                      :rownumintable="1"
                      :queryString="{ id: TaahodatSelectForNahve ? TaahodatSelectForNahve : 4009 }"
                      :action="'TblCombo/GettblComboById'"
                      :method="'GET'"
                      :idinput="'TaahodatSelectForNahve'"
                      :keyItem="'TaahodatSelectForNahve'"
                      :disabled="true"
                    >
                    </SearchableCombo>
                  </div>
                </div>
                <btn-save-data @Cancel="AddModeAzaTashilat = 0;Refresh()" @Success="IsSuccess" :ShowCancelButton="false" v-if="AddModeAzaTashilat == 1" :DataParanet="DataAxios"></btn-save-data>
                <btn-edit-data
                  @Cancel="
                    AddModeAzaTashilat = 0
                    Refresh()
                  "
                  @Success="IsSuccess"
                  :ShowCancelButton="false"
                  v-if="AddModeAzaTashilat == -1"
                  :DataParanet="DataAxios"
                ></btn-edit-data>
              </b-tab>
              <b-tab title="نحوه پرداخت | سایر اطلاعات ">
                <div class="row mt-2 border-bottom pb-4 ml-2 mr-2">
                  <div class="col-md-6 col-12 text-right">
                    <small>شرح تسهــیلات</small>
                    <textarea v-model="DataAxios.DesTaahod" type="text" class="form-control" rows="1"></textarea>
                  </div>
                  <div class="col-md-3 pr-0 col-12 text-right">
                    <small>شناســه واریز</small>
                    <input type="text" tabindex="-1" @keypress="$ValidNumber($event, 12)" class="form-control text-center InputText" style="direction: ltr" />
                  </div>
                  <div class="col-md-3 pr-0 col-12 text-right">
                    <small>شناســه </small>
                    <input type="text" tabindex="-1" @keypress="$ValidNumber($event, 12)" class="form-control text-center InputText" style="direction: ltr" />
                  </div>
                </div>
                <div class="row mt-4">
                  <div class="col-md-3 col-12 text-right">
                    <small> نحوه پرداخت وام </small>
                    <SearchableCombo
                      :edit="false"
                      :defaultvalue="DataAxios.TblComboNahveVarizVamMoshtari7"
                      @ResultCombo="ValueResultComboNahveVarizVamMoshtari7"
                      :rownumintable="1"
                      :queryString="{ id: 7 }"
                      :action="'TblCombo/GettblCombo'"
                      :method="'GET'"
                      :idinput="'TblComboNahveVarizVamMoshtari7'"
                      :keyItem="'TblComboNahveVarizVamMoshtari7'"
                      :disabled="false"
                    >
                    </SearchableCombo>
                  </div>
                  <div v-if="NahveVarizVam != 0 && NahveVarizVam != null && NahveVarizVam != 5402 && NahveVarizVam != 4014 && NahveVarizVam != 4197 && NahveVarizVam != 4085" class="col-md-2 col-10 text-right">
                    <small v-if="NahveVarizVam == 5774">واریز به حساب </small>
                    <small v-if="NahveVarizVam == 4146 || NahveVarizVam == 4128">شماره حساب </small>
                    <small v-if="NahveVarizVam == 4015 || NahveVarizVam == 4084">واریز به حساب </small>
                    <input
                      @focusout="ComplateVcode($event)"
                      v-if="NahveVarizVam == 5774 || NahveVarizVam == 4146 || NahveVarizVam == 4015 || NahveVarizVam == 4084 || NahveVarizVam == 4128"
                      v-mask="$session.get('UserInfo').codeShobe.trim() + '-##-######'"
                      :placeholder="$session.get('UserInfo').codeShobe.trim() + '-__-______'"
                      type="text"
                      @keypress="$ValidNumber($event, 16)"
                      class="form-control InputText"
                      style="direction: ltr"
                      id="TaahodatVarizBeHesab"
                      v-model="TaahodatVarizBeHesab"
                    />
                  </div>
                  <div v-if="NahveVarizVam != 0 && NahveVarizVam != null && NahveVarizVam != 5402 && NahveVarizVam != 4014 && NahveVarizVam != 4197 && NahveVarizVam != 4085" class="col-md-1 pr-0 mt-2 pb-2 col-2 text-right">
                    <button
                      v-if="NahveVarizVam == 5774 || NahveVarizVam == 4146 || NahveVarizVam == 4015 || NahveVarizVam == 4084 || NahveVarizVam == 4128"
                      type="button"
                      class="btn btn-success mt-3"
                      @click.prevent="IsVarizBeHesab = true;modal1=false;IsSearchTaahod=true;$store.state.Modal=true"
                      dir="ltr"
                    >
                      <i class="fa fa-list" tabindex="-1"></i>
                    </button>
                  </div>
                  <div v-if="NahveVarizVam == 4146 || (NahveVarizVam == 4128 && NahveVarizVam != 4014 && NahveVarizVam != 4197)" class="col-md-3 col-12 text-right pr-0">
                    <small>مشخصات</small>
                    <input type="text" disabled class="form-control text-center InputText" style="direction: ltr" />
                  </div>
                  <div v-if="NahveVarizVam == 5402 && NahveVarizVam != 4014 && NahveVarizVam != 4197" class="col-md-3 col-12 text-right pr-0">
                    <small>سرفصل واسط</small>
                    <SearchableCombo
                      :edit="false"
                      :defaultvalue="DataAxios.TblComboNahveVarizVamMoshtari7SarfaslVaset"
                      @ResultCombo="ValueResultComboNahveVarizVamMoshtari7SarfaslVaset"
                      :rownumintable="1"
                      :queryString="{ id: 7 }"
                      :action="'TblCombo/GettblCombo'"
                      :method="'GET'"
                      :idinput="'TblComboNahveVarizVamMoshtari7SarfaslVaset'"
                      :keyItem="'TblComboNahveVarizVamMoshtari7SarfaslVaset'"
                      :disabled="false"
                    >
                    </SearchableCombo>
                  </div>
                  <div v-if="NahveVarizVam == 4085 || NahveVarizVam == 5774 || NahveVarizVam == 4014 || NahveVarizVam == 4197 || NahveVarizVam == 4084" class="col-md-4 col-12 text-right pr-0">
                    <small>شرح حساب</small>
                    <SearchableCombo
                      :edit="false"
                      :defaultvalue="DataAxios.SarfaslBySarfaslTypeId"
                      @ResultCombo="ValueResultGetSarfaslBySarfaslTypeId"
                      :rownumintable="1"
                      :queryString="{ id: 4 }"
                      :action="'TblCombo/GetSarfaslBySarfaslTypeId'"
                      :method="'GET'"
                      :idinput="'SarfaslBySarfaslTypeId'"
                      :keyItem="'SarfaslBySarfaslTypeId'"
                      :disabled="false"
                    >
                    </SearchableCombo>
                  </div>
                </div>
                <div class="row mt-2" v-if="(NahveVarizVam != 0 && NahveVarizVam != null && NahveVarizVam == 4085) || NahveVarizVam == 5774 || NahveVarizVam == 4014 || NahveVarizVam == 4197">
                  <div class="col-md-3 col-12 mt-1 text-right">
                    <small>شماره حــواله </small>
                    <input type="text" tabindex="-1" @keypress="$ValidNumber($event, 12)" class="form-control text-center InputText" style="direction: ltr" v-model="DataAxios.ShomareHavaleBanki" />
                  </div>
                  <div class="col-md-3 col-12 mt-1 text-right">
                    <small> مبــلغ </small>
                    <input type="text" tabindex="-1" @keypress="$ValidNumber($event, 12)" class="form-control text-center InputText 3ragham" style="direction: ltr" v-model="DataAxios.MablaghCheck" />
                  </div>
                  <div class="col-md-3 col-12 mt-1 text-right">
                    <small> تاریخ </small>
                    <date-picker :editable="true" v-model="$store.state.JalaliDate" ></date-picker>
                  </div>
                </div>
                <div class="row mt-2" v-if="NahveVarizVam != 0 && NahveVarizVam != null">
                  <div class="col-md-2 col-12 mt-1 pl-0 text-right">
                    <small>مبلغ مسدود نمودن </small>
                    <input type="text" tabindex="-1" @keypress="$ValidNumber($event, 12)" class="form-control text-center InputText" v-model="DataAxios.MablaghMasdodNemodan" style="direction: ltr" />
                  </div>
                  <div class="col-md-2 col-12 mt-1 text-right">
                    <small> تاریخ واریز </small>
                    <date-picker :editable="true" v-model="DataAxios.TarixCheck"></date-picker>
                  </div>
                  <div class="col-md-2 col-12 mt-1 text-right">
                    <small> شروع مسدودی </small>
                    <date-picker :editable="true" v-model="DataAxios.TarixShoroMasdodi"></date-picker>
                  </div>
                  <div v-if="NahveVarizVam != 0 && NahveVarizVam != null" class="col-md-2 col-10 mt-1 text-right">
                    <small>حساب پرداخت اقساط </small>
                    <input
                      @focusout="ComplateVcode($event)"
                      v-mask="$session.get('UserInfo').codeShobe.trim() + '-##-######'"
                      :placeholder="$session.get('UserInfo').codeShobe.trim() + '-__-______'"
                      type="text"
                      @keypress="$ValidNumber($event, 16)"
                      class="form-control InputText"
                      style="direction: ltr"
                      id="HesabPardakhtAghsat"
                      v-model="TaahodatPardakhtAghsat"
                    />
                  </div>
                  <div v-if="NahveVarizVam != 0 && NahveVarizVam != null" class="col-md-1 pr-0 col-2 mt-2 pt-1 pl-0 text-right">
                    <button type="button" class="btn btn-success mt-3" @click.prevent="IsVarizBeHesab = false;modal1=false;IsSearchTaahod=true;$store.state.Modal=true" dir="ltr">
                      <i class="fa fa-list" tabindex="-1"></i>
                    </button>
                  </div>
                  <div class="col-md-3 col-12 mt-1 pr-0 text-right">
                    <small>مشخصات </small>
                    <input disabled type="text" tabindex="-1" id="Moshakhasat" @keypress="$ValidNumber($event, 12)" class="form-control text-center InputText" style="direction: ltr" />
                  </div>
                </div>
                <btn-save-data
                  @Cancel="
                    AddModeAzaTashilat = 0
                    Refresh()
                  "
                  @Success="IsSuccess"
                  :ShowCancelButton="false"
                  v-if="AddModeAzaTashilat == 1"
                  :DataParanet="DataAxios"
                ></btn-save-data>
                <btn-edit-data
                  @Cancel="AddModeAzaTashilat = 0
                    Refresh()
                  "
                  @Success="IsSuccess"
                  :ShowCancelButton="false"
                  v-if="AddModeAzaTashilat == -1"
                  :DataParanet="DataAxios"
                ></btn-edit-data>
              </b-tab>
            </b-tabs>
          </div>
        </div>
        <Bnp-Grid :Sortable="true" :action="true" :propsRows="rows" :propsColumn="column" :hasRowNum="true" v-if="$store.state.renderComponentGrid && AddModeAzaTashilat == 0">
          <template slot="action-slot" slot-scope="props">
            <i class="hover-danger mx-3 fad fa-trash text-secondary Pointer" @click="OnDelete(props.props)"></i>
            <i class="hover-warning mx-3 fad fa-marker text-secondary Pointer" @click="OnEdit(props.props)"></i>
            <i class="hover-info mx-3 fas fa-info text-secondary Pointer" @click="OnDetail(props.props)"></i>

            <b-dropdown size="md" variant="link" class="d-inline text-center" toggle-class="text-decoration-none mt-3" no-caret>
              <template #button-content
                ><h4><i class="fad fa-stream text-secondary"></i></h4
              ></template>
              <b-dropdown-item href="#" @click="GotoCart(props.props)" class="text-center">کارت تســهیلات</b-dropdown-item>
              <b-dropdown-item href="#" @click="GoToZamen(props.props)" class="text-center"> ضامنین</b-dropdown-item>
            </b-dropdown>
          </template>
        </Bnp-Grid>
      </template>
    </card>
    <modal v-if="$store.state.Modal" :InheritanceTheme="true" :IsFooter="false" :Size="'Lg'">
      <template v-slot:body>
        <dlg-cart-hesab v-if="modal1" :PropTarixAz="false" :AzaInfo="AzaInfo" :Vcode="Vcode"></dlg-cart-hesab>
        <SearchTaahod v-if="IsSearchTaahod" @Taahod="GetSearched"></SearchTaahod>
        
      </template>
    </modal>
  </div>
</template>
<script>
import Card from '@/components/Card/Card.vue'
import DetailUser from '@/components/BnpCash/SanadComponents/DetailUser.vue'
import BnpGrid from '@/components/BnpGrid/BnpGrid.vue'
import Modal from '@/pages/Modal/Modal.vue'
import DlgCartHesab from './DlgCartHesab.vue'
import SearchableCombo from '@/components/Combo/SearchableCombo.vue'
import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
import InputOption from '@/components/InputOption/InputOption.vue'
import BtnEditData from '@/components/BnpButtons/BtnEditData.vue'
import BtnSaveData from '@/components/BnpButtons/BtnSaveData.vue'
import SearchTaahod from '../../MnuOmorMali/SmnuHesabdari/SearchTaahod.vue'


export default {
  components: { Card, DetailUser, BnpGrid, Modal, DlgCartHesab, SearchableCombo, datePicker: VuePersianDatetimePicker, InputOption, BtnSaveData, BtnEditData,SearchTaahod },
  data() {
    return {
      modal1: false,
      rows: [],
      column: [],
      DataAxiosRow: {
        ArryfildValue: '',
        Method: 'post',
        Action: 'AzaTashilats',
        Token: this.$session.get('Token'),
      },
      Vcode: '',
      AddModeAzaTashilat: 0,
      DataAxios: {id:11, Vcode: '', Tarix: this.$GetJalaliDate(), TarixShoroAghsat: '',TarixCheck:this.$GetJalaliDate(),TblShobeId:null },
      TaahodatSelectForNahve: null,
      In_GetTarixShoroAghsat: {
        b_Tarix: '',
        b_NoeHasPrgPardakht: 'false',
        b_NoePrgDore: '',
        b_ComboPrgVahed4: '',
        b_Zarib: 0,
      },
      NahveVarizVam: 0,
      IsVarizBeHesab: false,
      TaahodatVarizBeHesab: null,
      TaahodatPardakhtAghsat: null,
      TaahodatIdBackup: null,
      DataAxios_FindShomareHesabOrTaahodat: {
        ArryfildValue: {},
      },
      AzaTashilats: {},
      b_TedadGhestVam_Leave:{},
      IsSearchTaahod:false,
      DataAxiosDelete: {
                ArryfildValue: '',
                Method: 'Delete',
                Action: this.$route.name,
                Token: this.$session.get('Token'),
            },
      Sweet: ['حذف اطلاعات', 'آیا از حذف این اطلاعات اطمینان دارید ؟', 'warning', false],
      IsSelectTashilatNoe:false
    }
  },
  methods: {
    Search() {
      try {
        this.DataAxiosRow.Action = this.$route.name + '/Index'
        this.DataAxiosRow.Method = 'POST'
        this.DataAxiosRow.ArryfildValue = {
          tblAzaId: this.AzaInfo.TblAzaId,
          tblShobeId: this.$session.get('UserInfo').tblShobeId,
          tblGrpId: this.$session.get('UserInfo').dbGrpId,
          tblEtayeVamId: 0,
        }
        this.$PostData(this.DataAxiosRow).then((data) => {
          if (data.length > 0) {
            this.rows = data
            for (let index = 0; index < this.rows.length; index++) {
              this.rows[index]['row'] = index + 1
            }

            this.$FormatMablaghGrid(this.rows)
            this.$store.state.renderComponentGrid = false
            this.$nextTick(() => {
              this.$store.state.renderComponentGrid = true
            })
          }
        })
        // this.GetItemCard()
      } catch (error) {
        console.log(error)
      }
    },
    GetGridColumns() {
      let DataAxoisCol = {
        ArryfildValue: {
          SoftwareId: this.$session.get('UserInfo').tblSoftwareId,
          UserId: this.$session.get('UserInfo').tblUserId,
          FormName: 'frmAzaTashilats',
          ShowView: 0,
        },
        Method: 'post',
        Action: 'ReadGridColumns',
      }
      this.$GetColumns(DataAxoisCol, true)
        .then((data) => {
          this.column = data
        })
        .finally(() => {
          this.$store.state.renderComponentGrid = false
          this.$nextTick(() => {
            this.$store.state.renderComponentGrid = true
          })
        })
    },
    GotoCart(row) {
      this.Vcode = row.Vcode
      this.modal1 = true
      this.$store.state.Modal = true
    },
    ValueResultNoe(val) {
      if (val.id != null) {
        this.IsSelectTashilatNoe=true
        this.DataAxios.TblNoeId = val.id
        if (this.AddModeAzaTashilat == 1) {
          this.GetVCodenew(val.element.Code, val.id)
          // ----
          this.DataAxios.TblComboNahveVarizVamMoshtari7 = val.element.List[0].TblComboNahveVariz7
          // this.DataAxios.TblComboNahveVarizVamMoshtari7 = val.element.List[0]
          this.b_TedadGhestVam_Leave = val.element.List[0]
          this.b_TedadGhestVam_Leave.tblUserGrpId = this.$session.get('UserInfo').tblGrpId

          this.In_GetTarixShoroAghsat.b_Zarib = this.b_TedadGhestVam_Leave.Zarib

          this.TaahodatSelectForNahve = val.element.List[0].TblComboNoeKarmozd6


          if (this.AddModeAzaTashilat == 1) {
            this.DataAxios.TedadGhestVam = val.element.List[0].TedadGhestVam
            this.DataAxios.MablaghVam = val.element.List[0].MablaghVam
            this.DataAxios.PrgDoreTaahod = val.element.List[0].PrgDore
            this.GetVCodenew(val.element.List[0].CodeNoe, val.element.List[0].Id)

            this.DataAxios.tblComboPrgVahedTaahodat4 = val.element.List[0].TblComboPrgVahed4
          } else {
            this.TaahodatSelectForNahve = val.element.List[0].TblComboNoeKarmozd6
          }
          this.$store.state.renderComponent = false
          this.$nextTick(() => {
            this.$store.state.renderComponent = true
          })
        }
      }
    },
    GetInfoDes(value) {
      this.DataAxios.tblMavaredMasrafVamId = value.Id
    },
    ValueResultTblComboPrgVahed4(value) {
      if (value != null) {
        this.In_GetTarixShoroAghsat.b_ComboPrgVahed4 = value.id
        this.CalcTarixShoroAghsat()
      }
    },
    ValueResultTaahodatSelectForNahve() {},

    FocusOut(e) {
      if (e.target.value != '0' && e.target.value == '') {
        e.target.value = '0'
      }
    },
    Focus(e) {
      if (e.target.value == '0' || (e.target.value == 0 && e.target.value != '')) {
        e.target.value = ''
      }
    },
    GetInfoDes(value) {
      this.DataAxios.tblMavaredMasrafVamId = value.Id
    },
    CalcTarixShoroAghsat() {
      this.In_GetTarixShoroAghsat.b_Tarix = this.$GetJalaliDate()

      this.In_GetTarixShoroAghsat.b_NoePrgDore = this.DataAxios.PrgDoreTaahod
      var DataAxios_GetTarixShoroAghsat = {
        ArryfildValue: this.In_GetTarixShoroAghsat,
        Method: 'post',
        Action: 'AzaTashilats/GetTarixShoroAghsat',
        Token: this.$session.get('Token'),
      }

      this.$PostData(DataAxios_GetTarixShoroAghsat).then((data) => {
        this.DataAxios.TarixShoroAghsat = data.tarixShoroAghsat
      })
    },
    CalcMablaghHarGhest() {
      if (this.AddModeAzaTashilat==-1) {
        this.CalcBedehiAvali(null, true)
      }
      var DataAxios_b_TedadGhestVam_Leave = {
        ArryfildValue: {},
        Method: 'post',
        Action: 'AzaTashilats/b_TedadGhestVam_Leave',
        Token: this.$session.get('Token'),
      }
      this.b_TedadGhestVam_Leave.TedadGhestVam = this.DataAxios.TedadGhestVam
      this.b_TedadGhestVam_Leave.TarixShoroAghsat = this.DataAxios.TarixShoroAghsat
      DataAxios_b_TedadGhestVam_Leave.ArryfildValue = this.b_TedadGhestVam_Leave
      this.$PostData(DataAxios_b_TedadGhestVam_Leave).then((data) => {
        this.DataAxios.MablaghGhestVam ? (this.DataAxios.MablaghGhestVam = data.mablaghGhest) : (this.DataAxios['MablaghGhestVam'] = this.$Comma3ragham(data.mablaghGhest))
        this.DataAxios.MablaghAvalinGhest ? (this.DataAxios.MablaghAvalinGhest = data.mablaghGhest) : (this.DataAxios['MablaghAvalinGhest'] = this.$Comma3ragham(data.mablaghGhest))
        this.DataAxios.MabLastGhest ? (this.DataAxios.MabLastGhest = data.mablaghGhest) : (this.DataAxios['MabLastGhest'] = this.$Comma3ragham(data.mablaghGhest))
      })
    },
    CalcBedehiAvali(e, CalcMablaghHarGhest) {
      if (e) {
        this.DataAxios.MablaghVam = e.target.value
        this.b_TedadGhestVam_Leave.MablaghVam = this.DataAxios.MablaghVam.replace(/,/g, '')
        this.DataAxios.SumMabBedehi = e.target.value
      } else if (CalcMablaghHarGhest) {
        this.b_TedadGhestVam_Leave.MablaghVam = this.DataAxios.MablaghVam.replace(/,/g, '')
        this.DataAxios.SumMabBedehi =document.getElementById('MablaghVam').value
      }
    },
    GetVCodenew(Code, noeid) {
      var DataAxiosGetVcodeNew = {
        ArryfildValue: {},
        Method: 'POST',
        Action: 'AzaInfo/GetVcodeNew',
        Token: this.$session.get('Token'),
      }
      DataAxiosGetVcodeNew.ArryfildValue = {
        tblNoeId: noeid,
        NoeCode: Code,
        tblShobeId: this.$session.get('UserInfo').tblShobeId,
        CodeShobe: this.$session.get('UserInfo').codeShobe,
        tblUserGrpId: this.$session.get('UserInfo').tblGrpId,
        b_IsPas: false,
      }
      let result
      this.$PostData(DataAxiosGetVcodeNew)
        .then(function (data) {
          result = JSON.stringify(data)
        })
        .finally(() => {
          result = JSON.parse(result)
          if (result.status == 'Ok') {
            this.DataAxios.Vcode = result.newShomare
          } else {
            this.$mySweetDefaultTost(' خطا', 'شماره حساب پشتیبان  صحیح نیست!!', 'error', 1500)
          }
        })
    },
    ValueResultComboNahveVarizVamMoshtari7(value) {
      this.NahveVarizVam = value.id
    },
    checkVcodeID() {
      var inputvcode = document.getElementById('Poshtiban').value
      if (inputvcode.length == 13) {
        if (this.BackVcodeID.Id != null && this.BackVcodeID.Vcode == inputvcode) {
          this.DataAxios.TblTaahodatIdBackup = this.BackVcodeID.Id
        } else {
          this.$mySweetDefaultTost('درحال جستوجو.', '', 'info')
          var DataAxiosgetTaahod = {
            ArryfildValue: {},
            Method: 'Post',
            Action: 'SearchTaahod/b_GetDataTaahod',
            Token: this.$session.get('Token'),
          }
          DataAxiosgetTaahod.ArryfildValue = {
            Id: this.$session.get('UserInfo').tblGrpId,
            Vcode: inputvcode,
            Taahodid: -1,
          }
          let x
          this.$PostData(DataAxiosgetTaahod)
            .then(function (data) {
              var result = JSON.stringify(data)
              x = result
            })
            .finally(() => {
              var res = JSON.parse(x)
              if (typeof res.msg != undefined) {
                this.$mySweetDefaultTost(' جستوجو موفق', '', 'success', 1500)
                this.backupMoshakhasat = res.NameFamily + ' - ' + res.DesNoe
                this.DataAxios.TblTaahodatIdBackup = res.Id
                this.BackVcodeID.Vcode = res.Vcode
                this.BackVcodeID.Id = res.Id
              } else {
                this.$mySweetDefaultTost(' خطا', 'شماره حساب وارد شده صحیح نیست!!', 'error', 1500)
              }
            })
        }
      }
    },
    GotoCart(row) {
      this.Vcode = row.Vcode
      this.modal1 = true
      this.$store.state.Modal = true
    },
    Refresh() {
      this.AddModeAzaTashilat = 0
      this.IsSelectTashilatNoe = false
      this.DataAxios = {id:11, Vcode: '', Tarix: this.$GetJalaliDate(), TarixShoroAghsat: '',TarixCheck:this.$GetJalaliDate() ,TblShobeId:null}
    },
    IsSuccess(value) {
      this.Refresh()
      this.Search()
      this.$store.state.renderComponentGrid = false
      this.$nextTick(() => {
        this.AddModeAzaTashilat = 0
        this.Search()
        this.$store.state.renderComponentGrid = true
      })
    },
   
    ValueResultGetSarfaslBySarfaslTypeId(){ 
    },
    ValueResultComboNahveVarizVamMoshtari7SarfaslVaset(val){ 
      this.DataAxios.tblSarfaslIdVaset?this.DataAxios.tblSarfaslIdVaset =val.id:this.DataAxios['tblSarfaslIdVaset'].tblSarfaslIdVaset=val.id
    },
    ComplateVcode(e) {
      var vcode = this.$session.get('b_SetVCodeMask').trim().substring(7).replaceAll('0', '#')
      e.target.value = e.target.value.replace(this.$session.get('UserInfo').codeShobe.trim() + '-', '')
      var CodeNoe = e.target.value.substring(0, 3)
      e.target.value = e.target.value.replace(e.target.value.substring(0, 3), '')
      e.target.value = e.target.value.padStart(vcode.length, 0)
      e.target.value = this.$session.get('UserInfo').codeShobe.trim() + '-' + CodeNoe + e.target.value
      this.DataAxios_FindShomareHesabOrTaahodat.ArryfildValue.Vcode =
        e.target.value;
      this.DataAxios_FindShomareHesabOrTaahodat.ArryfildValue.id =
        this.$session.get("UserInfo").tblGrpId;
      this.DataAxios_FindShomareHesabOrTaahodat.Method = "Post";
      this.DataAxios_FindShomareHesabOrTaahodat.Action =
        "SearchTaahod/b_GetDataTaahod";
      this.$PostData(this.DataAxios_FindShomareHesabOrTaahodat).then((data) => {
        if (this.IsVarizBeHesab == true) {
          this.DataAxios.TaahodatIdVarizBeHesab = data.id;
          this.DataAxios.ShomareHesabVariz = data.Vcode;
        } else {
          this.DataAxios.TblTaahodatIdBackup = data.id;
          document.getElementById("Moshakhasat").value =
            data.DesNoe + " - " + data.NameFamily;
        }
      });
    },
    //SearchTaahod
    GetSearched(row) {

      if(this.IsVarizBeHesab==false){

        this.DataAxios.TaahodatIdVarizBeHesab ? (this.DataAxios.TaahodatIdVarizBeHesab = row.Id) : (this.DataAxios['TaahodatIdVarizBeHesab'] = row.Id)
       this.TaahodatPardakhtAghsat = row.Vcode
       document.getElementById("Moshakhasat").value =
       row.DesNoe + " - " + row.OzvFamilyName;
      }
      else{
       this.DataAxios.TblTaahodatIdBackup ? (this.DataAxios.TblTaahodatIdBackup = row.Id) : (this.DataAxios['TblTaahodatIdBackup'] = row.Id)
       this.DataAxios.TaahodatIdBackup ? (this.DataAxios.TaahodatIdBackup = row.OzvFamilyName + ' - ' + row.DesNoe) : (this.DataAxios['TaahodatIdBackup'] = row.OzvFamilyName + ' - ' + row.DesNoe)
       this.TaahodatVarizBeHesab = row.Vcode

      }
      
    },
    OnEdit(row){
      console.log(row);
      this.$store.state.OldDataForLog= JSON.stringify(row)
      this.AddModeAzaTashilat=-1
      this.DataAxios=row
      this.DataAxios.TblNoeId=row.TblNoeId
      this.DataAxios.VcodeBackup=row.ShomareHesabBackup
      this.TaahodatVarizBeHesab=row.ShomareHesabBackup
    },
    OnDelete(data){
      this.$store.state.OldDataForLog = JSON.stringify(data)
            this.DataAxiosDelete.ArryfildValue = { id: data.Id }
             this.$DeleteDatapropmise(this.DataAxiosDelete, this.Sweet).then((result) => {
        if (result == true){
          this.Refresh()
          this.Search()
          this.$store.state.renderComponentGrid = false
            this.$nextTick(() => {
              this.$store.state.renderComponentGrid = true
            })
        }
      })
    }
  },
  props: ['AzaInfo'],
  mounted() {
    if (this.AzaInfo) {
      // console.warn(this.AzaInfo)
      this.Search()
      this.GetGridColumns()
      this.DataAxios.Tarix = this.$GetJalaliDate()
      this.DataAxios.tblAzaId = this.AzaInfo.Id
      this.DataAxios.TblShobeId =this.AzaInfo.TblShobeId
      // document.getElementById("TblNoeId").focus();
    } else {
      this.$router.push({ name: 'Vorodi' })
    }
  },
}
</script>
<style scoped></style>
